import { Input } from 'antd';
import { useState, useEffect } from 'react';

import './reset.less';

import IPhone from '@imgs/icons/phone.svg';

// 专用于 手机-座机号输入框 内部不做号码长度以及校验，只做简单的 座机号手机号区分 以及 座机区号位数区分
// 要和form一起使用，绑定form后，props.value会更新触发二次更新，二次更新可以处理数据格式
// 也可以单独在两个输入框onchange时去做，但是开发时间不够，后期优化使其可以脱离form。
export default function PhoneInput(props: any) {
  const NUMBER_REG = /^\d/;
  const PHONE_REG_0 = /^0/; // 开头为0则为座机
  const PHONE_REG_1 = /^(010|02[0-57-9])|(85[2-3])/; // 座机校验-区号为3位
  const { value, onChange } = props;
  const [num1, setNum1] = useState<string>(''); // 第一个输入框值
  const [num2, setNum2] = useState<string>(''); // 第二个输入框值
  const [randomId, setRamdomId] = useState<string>(''); // 外层唯一id 用于处理内部事件
  const [type, setType] = useState<1 | 2>(1); // 1 手机号输入模式-隐藏第二输入框 2 座机号输入模式-显示第二输入框
  const [ele, setEle] = useState<HTMLElement | null>(null); // 外层元素
  const [ele1, setEle1] = useState<HTMLInputElement | null>(null); // 第一个输入框
  const [ele2, setEle2] = useState<HTMLInputElement | null>(null); // 第二个输入框
  const [selectionPosition1, setSelectionPosition1] = useState<number>(0);
  const [selectionPosition2, setSelectionPosition2] = useState<number>(-1);
  const num1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(/\D+/, '');
    setNum1(val);
    const text = `${val}${num2}`;
    onChange?.(text);
  };
  const num2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(/\D+/, '');
    setNum2(val);
    const text = `${num1}${val}`;
    onChange?.(text);
  };

  useEffect(() => {
    // 生成随机id 用于获取元素
    setRamdomId(Math.random().toString(36).substr(-8));
  }, []);
  useEffect(() => {
    // 获取元素
    if (randomId) {
      setEle(document.getElementById(randomId));
      setEle1(
        document
          .getElementById(randomId)
          ?.getElementsByClassName('phone-input-control-one')[0]
          .getElementsByClassName('ant-input')[0] as HTMLInputElement
      );
      setEle2(
        document
          .getElementById(randomId)
          ?.getElementsByClassName(
            'phone-input-control-two'
          )[0] as HTMLInputElement
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [randomId]);
  useEffect(() => {
    const event = () => {
      // 监听是否聚焦于两个输入框其中之一，从而判断是否组件被聚焦，聚焦状态给外层加一个类名
      // phone-input-focused 用于增加聚焦样式，
      if (ele && ele1 && ele2) {
        if (
          (document.activeElement === ele1 ||
            !ele2 ||
            document.activeElement === ele2) &&
          (ele?.className || '').indexOf('phone-input-focused') === -1
        ) {
          ele?.setAttribute('class', `${ele?.className} phone-input-focused`);
        } else if (
          document.activeElement !== ele1 &&
          (!ele2 || document.activeElement !== ele2) &&
          (ele?.className || '').indexOf('phone-input-focused') > -1
        ) {
          ele?.setAttribute(
            'class',
            (ele?.className || '').split('phone-input-focused').join('')
          );
        }
      }
    };
    window.addEventListener('click', event);
    // 键盘事件监听，用于判断和控制光标位置，以及两个输入框的光标跳转，当前输入类型
    const keydownEvent = (e: KeyboardEvent) => {
      if (
        e.key === 'ArrowLeft' &&
        document.activeElement === ele2 &&
        !ele2?.selectionStart
      ) {
        ele1?.focus();
        setSelectionPosition1(num1.length);
        setSelectionPosition2(-1);
        setTimeout(() => {
          ele1?.setSelectionRange(num1.length, num1.length);
        });
      }
      if (
        e.key === 'ArrowRight' &&
        document.activeElement === ele1 &&
        ele1?.selectionStart === num1.length
      ) {
        ele2?.focus();
        setSelectionPosition1(-1);
        setSelectionPosition2(0);
        setTimeout(() => {
          ele2?.setSelectionRange(0, 0);
        });
      }
      if (document.activeElement === ele1 && e.key === 'Backspace') {
        setSelectionPosition1((ele1?.selectionStart || 1) - 1);
        setSelectionPosition2(-1);
        if (ele1?.value.length === 1 && ele1?.selectionStart) {
          setType(1);
        }
      } else if (
        document.activeElement === ele1 &&
        new RegExp(NUMBER_REG).test(e.key)
      ) {
        const value1 = ele1?.value + e.key;
        if (new RegExp(PHONE_REG_0).test(value1)) {
          if (type === 1) {
            setType(2);
          }
          if ((ele1?.value.length || 0) > 3) {
            if ((ele1?.selectionStart || 0) >= 3) {
              setSelectionPosition1(-1);
              setSelectionPosition2((ele1?.selectionStart || 3) - 3);
            } else {
              setSelectionPosition1(ele1?.selectionStart || 0);
              setSelectionPosition2(-1);
            }
          } else if (ele1?.value.length === 3) {
            if ((ele1?.selectionStart || 0) >= 3) {
              setSelectionPosition1(-1);
              setSelectionPosition2(1);
            } else {
              setSelectionPosition1((ele1?.selectionStart || 0) + 1);
              setSelectionPosition2(-1);
            }
          } else {
            setSelectionPosition1(value1.length);
            setSelectionPosition2(-1);
          }
        } else if (type === 2) {
          setType(1);
          setSelectionPosition1(1);
          setSelectionPosition2(-1);
        } else {
          setSelectionPosition1(value.length);
          setSelectionPosition2(-1);
        }
      } else if (
        document.activeElement === ele2 &&
        new RegExp(NUMBER_REG).test(e.key)
      ) {
        setSelectionPosition1(-1);
        setSelectionPosition2((ele2?.selectionStart || 0) + 1);
      } else if (document.activeElement === ele2 && e.key === 'Backspace') {
        if (!ele2?.selectionStart && !ele2?.selectionEnd) {
          ele1?.focus();
          setSelectionPosition1(num1.length - 1);
          setSelectionPosition2(-1);
        } else if (ele2.value.length === 1) {
          setTimeout(() => {
            ele1?.focus();
            setSelectionPosition1(num1.length - 1);
            setSelectionPosition2(-1);
          }, 20);
        } else {
          setSelectionPosition1(-1);
          setSelectionPosition2((ele2?.selectionStart || 1) - 1);
        }
      }
    };
    window.addEventListener('keydown', keydownEvent);
    return () => {
      window.removeEventListener('click', event);
      window.removeEventListener('keydown', keydownEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ele, ele1, ele2, num1, num2]);
  useEffect(() => {
    // 覆盖值 - 同时处理数据 - 座机分割区号
    if (!value) {
      return;
    }
    if (value[0] !== '0') {
      setNum1(value);
      setNum2('');
      if (type === 2) {
        setType(1);
      }
    } else if (value[0] === '0') {
      if (type === 1) {
        setType(2);
      }
      if (new RegExp(PHONE_REG_1).test(value)) {
        setNum1(value.slice(0, 3));
        setNum2(value.slice(3));
      } else {
        setNum1(value.slice(0, 4));
        setNum2(value.slice(4));
      }
      setTimeout(() => {
        if (selectionPosition1 !== -1) {
          ele1?.focus();
          ele1?.setSelectionRange(selectionPosition1, selectionPosition1);
        }
        if (selectionPosition2 !== -1) {
          ele2?.focus();
          ele2?.setSelectionRange(selectionPosition2, selectionPosition2);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div
      id={randomId}
      className='phone-input'
      style={{ width: props.width || 'auto' }}
    >
      <Input
        id='contactPhoneNo'
        value={num1}
        prefix={
          <IPhone
            width={15}
            height={15}
            className={'phone-input-prefix-icon'}
          />
        }
        onChange={num1Change}
        className={`phone-input-control-one ${type === 1 ? 'tel' : ''}`}
      />
      <Input
        className={`phone-input-control-two ${type === 1 ? 'tel' : ''}`}
        value={num2}
        onChange={num2Change}
      />
    </div>
  );
}
